import 'vite/modulepreload-polyfill'
import './main.sass'


(() => console.log('💙 TamToMy dev was here 👀'))();

(() => {
    var productDetail = document.querySelector('.p-detail');
    if (!productDetail) return;

    var shortDesc = productDetail.querySelector('.p-short-description');
    var longDesc = document.querySelector('#description'); // sem se bude scrollovat

    if (!shortDesc || !longDesc) return;

    var link = document.createElement('a');
    link.href = '#description';
    link.textContent = 'Zobrazit podrobný popis';
    link.className = 'btn btn-secondary p-short-description-more';

    link.addEventListener('click', function (e) {
        e.preventDefault();
        longDesc.scrollIntoView({ behavior: 'smooth' });
    });

    var br = document.createElement('br');
    shortDesc.appendChild(br);
    shortDesc.appendChild(link);
})();

(()=> {
    var footer =
        document.querySelector('.custom-footer')

    if (!footer) return;

    var box = document.createElement('div');
    box.className = 'custom-footer__categories';

    box.innerHTML = `
    <h4>Kategorie</h4>
    <ul>
      <li><a href="/sauny-a-infrasauny/">Sauny a infrasauny</a></li>
      <li><a href="/kamna-a-topidla-pro-sauny/">Kamna a topidla</a></li>
      <li><a href="/aromaterapie/">Aromaterapie</a></li>
      <li><a href="/saunove-prislusenstvi/">Saunové příslušenství</a></li>
      <li><a href="/wellness-relax/">Wellness & Relax</a></li>
    </ul>
  `;

    if (footer.firstElementChild) {
        footer.insertBefore(box, footer.firstElementChild)
    } else {
        footer.appendChild(box)
    }
})();



